/**
 * Custom js to display homepage slider
 *
 * @since		09/21/2020
 * @author		<john@chatmandesign.com>
 * @link		http://chatmandesign.com
 */
(function($) {

    let arriveOptions = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

    let searchDisplay   = '.search-display';
    let searchForm      = searchDisplay + '__form';
    let searchIcon      = searchDisplay + '__icon';
    let searchField     = searchForm + ' .search-field';
    let searchClose     = searchForm + ' .close';

    function searchDisplayAppendForm() {
        let parentRow = $(searchForm).parents('.row');
        if( parentRow.length ) {
            $(searchForm).appendTo(parentRow);
        }
    }

    function searchIconOnClick(e) {
        e.preventDefault();
        $(searchForm).css('display', 'block');
        setTimeout(function() {
            $(searchForm).addClass('slide-in');
            $(searchField).focus();
        }, 10);
    }

    function closeSearchOnClick(e) {
        e.preventDefault();
        $(searchForm).removeClass('slide-in');
        $(searchForm).addClass('slide-out');
        setTimeout(function() {
            $(searchForm).css('display', 'none');
            $(searchForm).removeClass('slide-out');
        }, 300); // 0.3s for hover transition
    }

    //waitForElement(searchDisplay, searchDisplayAppendForm);

    $(document).arrive(searchDisplay, arriveOptions, searchDisplayAppendForm);


    //! – DOM READY
    $(function() {
        if( $(searchIcon).length ) {
            $(searchIcon).each(function() {
                $(this).on('click', function(e) {
                    searchIconOnClick(e);
                });
            });
        }
        if( $(searchClose).length ) {
            $(searchClose).on('click', function(e) { closeSearchOnClick(e); });
        }        
    });

})(jQuery);